import React, { useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  iterateBranchingNodes,
  remainingNodeChainSelector,
  virtualHumanTalkingSelector,
  waitThenIterateBranchingNodes,
  waitingOnUserContinueSelector,
  waitGivenAmountThenIterateBranchingNodes,
  selectChatsCount,
  markedToCompleteWhenFinishedTalkingSelector,
  completeSession,
  selectChatState,
  ChatStates,
} from '../../../../slices/chat/ChatSlice';
import { virtualHumanDataSelector } from '../../../../slices/VirtualHumanSlice';
import { usePrevious } from '../../../../utility/StateHooks';

// created this because hooks can't be conditionally called (components can, obviously)
const RootBranchingBehaviorHandler = (props) => {
  const virtualHumanTalking = useSelector(virtualHumanTalkingSelector);
  const prevVirtualHumanTalking = usePrevious(virtualHumanTalking);
  const remainingNodeChain = useSelector(remainingNodeChainSelector);
  const waitingOnUserContinue = useSelector(waitingOnUserContinueSelector);
  const prevNodeChain = usePrevious(remainingNodeChain);
  const iterateOnVoiceComplete = useRef(false);
  const dispatch = useDispatch();
  const chatsCount = useSelector(selectChatsCount);

  // set off initial chat when node chain has been received
  // or set so that it will iterate if vh is currently talking, once it has finished talking
  useEffect(() => {
    if (waitingOnUserContinue) {
      return;
    }
    if (remainingNodeChain.length > 0 && prevNodeChain?.length === 0) {
      if (virtualHumanTalking) {
        iterateOnVoiceComplete.current = true;
      } else if (chatsCount > 0) {
        // we want to wait after user options are sent (presumably for UX reasons)
        dispatch(waitGivenAmountThenIterateBranchingNodes(1500));
      } else {
        // don't want a delay for first item
        dispatch(iterateBranchingNodes());
      }
    }
  }, [
    remainingNodeChain,
    prevNodeChain,
    virtualHumanTalking,
    dispatch,
    waitingOnUserContinue,
    chatsCount,
  ]);

  // continue speaking if necessary when there's no audio
  useEffect(() => {
    if (
      remainingNodeChain.length > 0 &&
      remainingNodeChain[0].audioBuffer === null &&
      remainingNodeChain[0].audioUrl === null
    ) {
      waitThenIterateBranchingNodes(true);
    }
  }, [remainingNodeChain]);

  // continue speaking if necessary when bot finishes talking
  useEffect(() => {
    if (waitingOnUserContinue) {
      return;
    }
    if (
      prevVirtualHumanTalking &&
      !virtualHumanTalking &&
      remainingNodeChain.length > 0
    ) {
      dispatch(iterateBranchingNodes());
    }
  }, [
    prevVirtualHumanTalking,
    virtualHumanTalking,
    remainingNodeChain,
    dispatch,
    waitingOnUserContinue,
  ]);
  const vh = useSelector(virtualHumanDataSelector);
  const chatState = useSelector(selectChatState);

  const markedToCompleteWhenFinishedTalking = useSelector(
    markedToCompleteWhenFinishedTalkingSelector
  );
  // // complete if marked to complete and vh finishes talking
  // useEffect(() => {
  //   if (
  //     markedToCompleteWhenFinishedTalking &&
  //     !virtualHumanTalking &&
  //     remainingNodeChain?.length === 0 &&
  //     chatState === ChatStates.TALK
  //   ) {
  //     dispatch(
  //       completeSession({
  //         patientId: vh.ExternalID,
  //       })
  //     );
  //   }
  // }, [
  //   dispatch,
  //   markedToCompleteWhenFinishedTalking,
  //   virtualHumanTalking,
  //   remainingNodeChain?.length,
  //   vh?.ExternalID,
  //   chatState,
  // ]);

  return <></>;
};

export default RootBranchingBehaviorHandler;
